// import React, { createContext, useState, useEffect } from 'react';
// import axios from 'axios';

// export const AuthContext = createContext();

// export const AuthProvider = ({ children }) => {
//   const [isAuthenticated, setIsAuthenticated] = useState(false);
//   const [user, setUser] = useState(null);
//   const [hasPaid, setHasPaid] = useState(false); // New state to track payment status
  

//   useEffect(() => {
//     const checkAuthStatus = async () => {
//       try {
//         const response = await axios.get('/auth/status', { withCredentials: true });
//         if (response.data.isAuthenticated) {
//           setIsAuthenticated(true);
//           setUser(response.data.user);
//           setHasPaid(response.data.user.paid); // Set payment status
//         } else {
//           setIsAuthenticated(false);
//           setUser(null);
//           setHasPaid(false);
//         }
//       } catch (err) {
//         console.error('Error checking authentication status:', err);
//         setIsAuthenticated(false);
//         setUser(null);
//         setHasPaid(false);
//       }
//     };

//     checkAuthStatus();
//   }, []);

//   return (
//     <AuthContext.Provider value={{ isAuthenticated, user, hasPaid, setIsAuthenticated, setUser, setHasPaid }}>
//       {children}
//     </AuthContext.Provider>
//   );
// };


// AuthContext.js
import React, { createContext, useState, useEffect } from 'react';
import axios from 'axios';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // useEffect(() => {
  //   const checkAuth = async () => {
  //     try {
  //       const response = await axios.get('/auth/status', {
  //         withCredentials: true
  //       });
        
  //       if (response.data.isAuthenticated) {
  //         setIsAuthenticated(true);
  //         setUser(response.data.user);
  //       }
  //     } catch (error) {
  //       console.error('Auth check failed:', error);
  //       setIsAuthenticated(false);
  //       setUser(null);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   checkAuth();
  // }, []);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const response = await axios.get('/auth/status', {
          withCredentials: true
        });
        
        if (response.data.isAuthenticated) {
          setIsAuthenticated(true);
          setUser(response.data.user);
        } else {
          setIsAuthenticated(false);
          setUser(null);
        }
      } catch (error) {
        console.error('Auth check failed:', error);
        setIsAuthenticated(false);
        setUser(null);
      } finally {
        setLoading(false);
      }
    };
  
    checkAuth();
  }, []);


  const logout = async () => {
    try {
      await axios.get('/auth/logout', { withCredentials: true });
      setIsAuthenticated(false);
      setUser(null);
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  return (
    <AuthContext.Provider value={{
      isAuthenticated,
      user,
      loading,
      setIsAuthenticated,
      setUser,
      logout
    }}>
      {!loading && children}
    </AuthContext.Provider>
  );
};